import { render } from "./ShowProduction.vue?vue&type=template&id=49b4cd06"
import script from "./ShowProduction.vue?vue&type=script&lang=js"
export * from "./ShowProduction.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/harvested_batch.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fopen_queries%2Forganization%2Fbasic_production%2Fprocess%2FShowProduction.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__